module.exports = __webpack_public_path__ + "static/media/survey-icon.bf48db60.png";